import { Component, Type, Input, OnDestroy } from '@angular/core';
import { DataItem } from '../../models/data-item';
import { FieldsetModule } from 'primeng/fieldset';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';


@Component({
    selector: 'app-data-box',
    imports: [
        CommonModule,
        FormsModule,
        FieldsetModule
    ],
    templateUrl: './data-box.component.html',
    styleUrl: './data-box.component.scss',
    providers: [DialogService]
})
export class DataBoxComponent implements OnDestroy {

  ref: DynamicDialogRef | undefined;

  @Input() headerTitle?: string;
  @Input() footer?: string;
  @Input() dataBoxItems: DataItem[] | undefined;
  @Input() helpComponent?: Type<any>; 

  constructor(public dialogService: DialogService) {}

  onHelpClicked(): void {
    if(this.helpComponent) {
      this.ref = this.dialogService.open(this.helpComponent, {
        header: this.headerTitle,
        width: "50vw",
        modal: true,
        dismissableMask: true,
        closable: true,
        breakpoints: {
          '500px': '98vw'
        },
        contentStyle: { 'background': 'var(--surface-100)'},
        footer: this.footer
      });
    }
  }

  ngOnDestroy(): void {
    if (this.ref) {
      this.ref.close();
    }
  }

  fieldSet = {
    root: {
      background: 'transparent',
      borderColor: 'var(--p-surface-400)',
      padding: '0px 8px 8px 8px',
    },
    legend: {
      borderColor: 'transparent',
    },
    content: {
      padding: '0 8px'
    },
    colorScheme: {
      legend: {
        background: 'transparent',
      }
    }
  }
}
